import { UserDetailsFormDataUserEdit } from './UserDetailsFormDataUserEdit';

export class UserDetailsFormData {
  tenantUserEdit: UserDetailsFormDataUserEdit = new UserDetailsFormDataUserEdit();
}
